import mutations from './mutations'
import getters from './getters'
import actions from './actions'

const state = {
  selectedSource: '',
  // logo的信息
  LogoMessage: {},
  // 通过websocket获取的设备信息
  broadcastUrl: '',
  listFeatures: [],
  // 编辑状态信息
  BeEditingMessage: {},
  // Clone禁止控制
  CloneDisabled: {
    VideoAdd: false, // 视频添加
    VideoEdit: false, // 视频编辑
    VideoDelete: false, // 视频删除
    videoDownload: false, // 视频下载
    Template: false, // 模板
    Drag: false, // 拖拽
    Event: false,
    Logo: false,
    Crawl: false,
    Scte: false,
    Singular: false,
    Output: false,
    SpotCoverOn: false, // 插播盖播事件
    OverlaySwitch: false, // 覆盖层开关
    PlugFlow: false, // 推流
    startingUpHint: false, // 开机提示
    disableButton: false, // disable模式下禁止按钮,
    playout: false,
    scheduler: false,
    Media: false, // 是否显示media侧边栏
    liveSource: false, // 是否显示liveSource侧边栏
    programTemplate: false, // 是否显示programTemplate侧边栏
    scheduleTemplate: false, // 是否显示scheduleTemplate侧边栏
    searchAndRepalce: false// 是否显示searchAndRepalce侧边栏
  },
  // 权限配置
  PermissionConfig: {
    schedulerOnly: ['playout'],
    playoutOnly: ['scheduler'],
    OperatorOnly: ['playout', 'scheduler'],
    ContentEditor: ['VideoDelete', 'Drag', 'Template', 'Event', 'Logo', 'Crawl', 'Scte', 'Singular', 'SpotCoverOn', 'OverlaySwitch', 'PlugFlow', 'scheduler', 'Output', 'programTemplate']
  },
  permissionList: [
    { name: 'coAdmin', roles: 3 },
    { name: 'editor', roles: 0 },
    { name: 'schedulerOnly', roles: 2 },
    { name: 'playoutOnly', roles: 4 },
    { name: 'OperatorOnly', roles: 5 },
    { name: 'ContentEditor', roles: 6 }
  ],
  // 多选文件拖拽列表
  PitchOnFileList: {
  },
  // Undo当前所在状态
  UndoCurrentType: '', // eventEdit,ProgramTemplateEdit,ScheduleTemplateEdit,ScheduleTemplate
  // 用户在当前channel权限
  UserChannelPermission: '',
  // 高级设置里面配置
  AdvancedSetupConfig: {},
  // 编辑中LBand信息
  lBandInfo: {},
  // ctrl+c 复制的事件
  CtrlCopyEvent: []
}

export default {
  namespaced: true,
  state,
  getters,
  mutations,
  actions
}
